import { createStructuredSelector } from "reselect";
import { makeSelectAppFormError, makeSelectPasswordResetSent } from "../../../app/appSelectors";
import { passwordResetAction, passwordResetReset } from "../loginActions";
import { connect } from "react-redux";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext";
import { useCallback, useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { RouterPaths } from "../../../app/appConstants";
import ResendCodeButton from "./ResendCodeButton";

function ForgotPasswordContent(props) {
    const {getLangPath} = useLangContext();
    const {
        formError,
        resetPassword,
        passwordResetSent,
        resetPasswordReset,
    } = props;

    const [email, setEmail] = useState('');

    useEffect(() => () => resetPasswordReset(), [resetPasswordReset])

    const submitHandler = useCallback((e) => {
        e.preventDefault();
        const email = e.target.querySelector('[name=email]').value;
        resetPassword({email});
        setEmail(email);
    }, [resetPassword]);

    if (passwordResetSent) {
        return <>
            <h1 className="forgot-password-content__check-email-title">
                {getLangPath('reset_password.check_email')}
            </h1>
            <p className="mt-4">
                {getLangPath('reset_password.follow_link')}
            </p>
            <p className="mb-0">{getLangPath('reset_password.resend_email')} {getLangPath('reset_password.resend_link')}</p>
            <ResendCodeButton email={email} requestType="reset" className="w-100 mt-4"/>
            <div className="d-flex flex-column mt-3">
                <Button variant={'outline-info'} size={'md'} as={Link} to={RouterPaths.login} type="button">
                    {getLangPath('log_in.back_to_login')}
                </Button>
            </div>
        </>
    }

    return <>
        <h1 className="forgot-password-content__title">{getLangPath('reset_password.title')}</h1>
        <p className="forgot-password-content__description">{getLangPath('reset_password.enter_email')}</p>
        <Form onSubmit={submitHandler}>
            <Form.Group className="forgot-password-content__email">
                <Form.Control name="email" type="email" placeholder={getLangPath('promo.fx.errors.email1')} isInvalid={formError} required/>
                {
                    formError && <>
                        <Form.Control.Feedback type="invalid">
                            {getLangPath(formError)}
                        </Form.Control.Feedback>
                    </>
                }
            </Form.Group>

            <div className="d-grid forgot-password-content__buttons-panel">
                <Button variant={'primary'} size={'lg'} type="submit" className="mb-4">
                    {getLangPath('reset_password.title')}
                </Button>
                <Button variant={'outline-info'} size={'md'} as={Link} to={RouterPaths.login} type="button">
                    {getLangPath('log_in.back_to_login')}
                </Button>
            </div>
        </Form>
    </>
}


const mapStateToProps = createStructuredSelector({
    passwordResetSent: makeSelectPasswordResetSent(),
    formError: makeSelectAppFormError(),
});

const mapDispatchToProps = (dispatch) => ({
    resetPassword: (payload) => dispatch(passwordResetAction(payload)),
    resetPasswordReset: (payload) => dispatch(passwordResetReset(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordContent);